import ReactPlaidLink from './ReactPlaidLink';
import store from '~/javascripts/store.js';
import t from '~/javascripts/utils/translation';
import { Children, Component, cloneElement } from 'react';

class PlaidBaseComponent extends Component {
  onSubmitClick = (event) => {
    event.preventDefault();

    if (this.props.onSubmitClick) {
      this.props.onSubmitClick();
    }
  };

  onSuccess = (publicToken, metadata) => {
    if (this.props.onSuccess) {
      this.props.onSuccess(publicToken, metadata);
    }
  };

  onExit = (error, _metadata) => {
    if (this.props.onExit) {
      this.props.onExit(error);
    }
  };

  renderChildren = () =>
    Children.map(this.props.children, (child) =>
      cloneElement(child, {
        onClick: this.onSubmitClick,
        ref: 'plaidSubmitElement',
        disabled: store.donateForm.disableFormSubmit,
      })
    );

  render() {
    return (
      <span className='PlaidBaseComponent'>
        <div className={this.props.layoutClasses}>
          <ReactPlaidLink
            clientName='charity: water'
            onExit={this.onExit}
            onSuccess={this.onSuccess}
            plaidEnv={this.props.plaidEnv}
            product='auth'
            selectAccount={true}
          >
            <>
              {this.renderChildren()}
              {store.donateForm.isMycwSubscription && (
                <p
                  className='h80 text-grey-60 mt-2'
                  dangerouslySetInnerHTML={{
                    __html: t('views.donate_form.mycw_subscription_disclaimer'),
                  }}
                />
              )}
            </>
          </ReactPlaidLink>
        </div>
      </span>
    );
  }
}

export default PlaidBaseComponent;
